import { CircularProgress } from '@packages/shared/src/ui/CircularProgress/CircularProgress';
import type { ReactNode } from 'react';
import { classes } from '../../utils/classes';

/**
 * Wrapper for forms that renders the Loader on a white background on top of the form if showLoader
 * is set to true.
 *
 * If you don't provide children you should provide a parent
 * element with "position: relative".
 */
export const ActivityOverlay = ({
  showLoader,
  children,
}: {
  showLoader: boolean;
  children?: ReactNode;
}) => (
  <div className={classes(!!children && 'relative')}>
    {children}
    {showLoader && (
      <div className="z-app-bar bg-color-backdrop absolute top-0 left-0 flex size-full items-center justify-center">
        <CircularProgress className="size-1" />
      </div>
    )}
  </div>
);
